import { ErrorBase } from '@/errors/ErrorBase';

export class NetworkError extends ErrorBase {
    static get defaultMessage(): string {
        return 'ネットワークエラーが発生しました。インターネットの設定やフィルターの設定を確認してください。';
    }

    static get errorName(): string {
        return 'NetworkError';
    }
}
